import React from 'react';
import Table from '../Table/Table';
import style from './InstitutionalOwnership.module.css';

const InstitutionalOwnership = ({ data }) => {
  if (!data) {
    return (
      <div>
        <h3 className={style.headline}>Institutional Ownership</h3>
        <p className={style.noData}>No data available for the latest quarter.</p>
      </div>
    );
  }

  const formatNumber = (num) => {
    if (!num) return '-';
    return new Intl.NumberFormat('en-US').format(num);
  };

  const formatCurrency = (num) => {
    if (!num) return '-';
    // Billions or Millions
    if (num > 1000000000) {
      return `$${(num / 1000000000).toFixed(2)}B`;
    }
    if (num > 1000000) {
      return `$${(num / 1000000).toFixed(2)}M`;
    }
    return `$${new Intl.NumberFormat('en-US').format(num)}`;
  };

  const renderChange = (value) => {
    if (value === null || value === undefined || isNaN(value)) return null;
    const num = parseFloat(value);
    if (isNaN(num)) return null;
    
    if (num === 0) return <span className={style.change}>0%</span>;
    const isPositive = num > 0;
    return (
      <span className={`${style.change} ${isPositive ? style.positive : style.negative}`}>
        {isPositive ? '▲' : '▼'} {Math.abs(num).toFixed(2)}%
      </span>
    );
  };

  const calculateChange = (current, last) => {
    if (!last || last === 0) return null;
    return ((current - last) / last) * 100;
  };

  return (
    <div>
      <h3 className={style.headline}>Institutional Ownership</h3>
      <p className={style.text}>
        Holdings and activity of institutional investors.
      </p>
      
      <Table>
        <tbody>
          <tr>
            <th>Ownership %</th>
            <td className={style.value}>
              {parseFloat(data.ownership_percent).toFixed(2)}%
              {renderChange(data.ownership_percent_change)}
            </td>
          </tr>
          <tr>
            <th>Total Invested</th>
            <td className={style.value}>
              {formatCurrency(data.total_invested)}
              {renderChange(data.total_invested_change && data.last_total_invested ? calculateChange(data.total_invested, data.last_total_invested) : null)} 
            </td>
          </tr>
          <tr>
            <th>Investors Holding</th>
            <td className={style.value}>
              {formatNumber(data.investors_holding)}
              {renderChange(data.investors_holding_change)}
            </td>
          </tr>
        </tbody>
      </Table>
    </div>
  );
};

export default InstitutionalOwnership;
